/**
 * Access Data
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */

/**
 * Access Control Rights
 */
export const AccessControlRights = {
    READ: "R",
    WRITE: "W",
    NONE: ""
};

/**
 * Access Control
 */
export class AccessControl {
    public id: string;
    public permission: string;
}

/**
 * Access Control List
 */
export class AccessControlList {
    private functionAC: Object;

    /**
     * Initialize
     */
    constructor() {
        this.functionAC = {};
    }

    /**
     * Gets Function Access Control
     * 
     * @param functionId Function Id
     */
    public getFunctionAccess(functionId: string): AccessControl {
        if (!functionId) {
            return null;
        }
        return <AccessControl>this.functionAC[functionId];
    }

    /**
     * Sets Function Access Control
     * 
     * @param functionId Function Id
     */
    public updateFunctionAccess(ac: AccessControl): void {
        if (!ac || !ac.id) {
            return;
        }
        this.functionAC[ac.id] = ac;
    }
}

/**
 * Function Access Control
 */
export class FunctionAccessControl {
    private functionAC: AccessControl;
    private subFunctionAC: Object;

    /**
     * Initialize
     */
    constructor() {
        this.functionAC = null;
        this.subFunctionAC = {};
    }

    /**
     * Gets Function Access Control
     */
    public getFunctionAccess(): AccessControl {
        return this.functionAC;
    }

    /**
     * Sets Function Access Control
     * 
     * @param functionId Function Id
     */
    public updateFunctionAccess(ac: AccessControl): void {
        if (!ac) {
            return;
        }
        this.functionAC = ac;
    }

    /**
     * Gets Sub Function Access Control
     * 
     * @param subFunctionId Sub Function Id
     */
    public getSubFunctionAccess(subFunctionId: string): AccessControl {
        if (!subFunctionId) {
            return null;
        }
        return <AccessControl>this.subFunctionAC[subFunctionId];
    }

    /**
     * Sets Sub Function Access Control
     * 
     * @param functionId Sub Function Id
     */
    public updateSubFunctionAccess(subAc: AccessControl): void {
        if (!subAc || !subAc.id) {
            return;
        }
        this.subFunctionAC[subAc.id] = subAc;
    }
}
